/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Slot_Generation_Day_LabelInputs */

const en_job_form_slot_generation_day_label = /** @type {(inputs: Job_Form_Slot_Generation_Day_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day`)
};

const de_job_form_slot_generation_day_label = /** @type {(inputs: Job_Form_Slot_Generation_Day_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag`)
};

/**
* | output |
* | --- |
* | "Day" |
*
* @param {Job_Form_Slot_Generation_Day_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_slot_generation_day_label = /** @type {((inputs?: Job_Form_Slot_Generation_Day_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Slot_Generation_Day_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_slot_generation_day_label(inputs)
	return en_job_form_slot_generation_day_label(inputs)
});